// Reducer for all the store
import * as libCon from '../../community-hats-js-library/Constants.js';
import * as locCon from '../../LocalConstants';
import { getPersistedLocale } from '../../hooks/LanguageHooks';
import participant_data from '../../data/exhibits/flipping_cards_participant_data.json';
import satelite_data from '../../data/exhibits/satelite_data.json';

// Initial State
export const initialState = {
  // Status
  [libCon.STATUS_DATASET_PARTICIPANTS]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_SENSORS]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_HOUSES]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_EMAILS]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_PARTICIPANT_PLACEMENT]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_SENSOR_HOUSE_PLACEMENT]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_RECEIVED_SENSOR_FILES]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_ISSUES]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_GOVEE_ACTIVATION_CODES]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_COLLECTION_RECORDS]: libCon.STATUS_NOT_STARTED,
  [libCon.STATUS_DATASET_COVERAGE_SUMMARY]: libCon.STATUS_NOT_STARTED,

  // Dataset
  [libCon.DATASET_PARTICIPANTS]: null,
  [libCon.DATASET_SENSORS]: null,
  [libCon.DATASET_HOUSES]: null,
  [libCon.DATASET_EMAILS]: null,
  [libCon.DATASET_PARTICIPANT_PLACEMENT]: null,
  [libCon.DATASET_SENSOR_HOUSE_PLACEMENT]: null,
  [libCon.DATASET_RECEIVED_SENSOR_FILES]: null,
  [libCon.DATASET_ISSUES]: null,
  [libCon.DATASET_GOVEE_ACTIVATION_CODES]: null,
  [libCon.DATASET_COLLECTION_RECORDS]: null,
  [libCon.DATASET_COVERAGE_SUMMARY]: null,

  // Variables
  [locCon.SELECTED_PARTICIPANT]: null,
  [locCon.USER_TYPE]: locCon.USER_TYPE_OUTSIDE_COLLABORATOR,

  // Language
  [locCon.CURRENT_LOCALE]: getPersistedLocale(),

  // Locations
  [locCon.PROJECT_LOCATION]: null,

  // Exhibition
  [locCon.EXHIBITION_FC_PARTICIPANT_DATA_STATUS]: libCon.STATUS_OK,
  [locCon.EXHIBITION_FC_SATELITE_WEATHER_STATUS]: libCon.STATUS_OK,

  [locCon.EXHIBITION_FC_PARTICIPANT_DATA]: participant_data,
  [locCon.EXHIBITION_FC_SATELITE_WEATHER]: satelite_data,
};

/**
 * Main actions function.
 * The structure of the function is a main switch with a final clean-up section at the end
 * @param {object} state - Current state of the store
 * @param {object} action  - Object containing the action and the payload
 * @returns The new state
 */
export default function setStateFun(state = initialState, action) {
  switch (action.type) {
    case locCon.SET_VALUE:
      state = { ...state, [action.payload[libCon.ID]]: action.payload[libCon.VALUE] };
      break;

    case locCon.UPDATE_OBJECT_VALUE:
      state = {
        ...state,
        [action.payload[libCon.ID]]: { ...state[action.payload[libCon.ID]], ...action.payload[libCon.VALUE] },
      };
      break;

    case locCon.RESET_ALL_DATASETS:
      // Dataset Keys
      const isStatus = (k) => k.startsWith(libCon.STATUS_DATASET_PREFIX);
      const isDataset = (k) => k.startsWith(libCon.DATASET_PREFIX);

      Object.keys(state).forEach((k) => {
        if (isStatus(k)) state[k] = libCon.STATUS_NOT_STARTED;
        if (isDataset(k)) state[k] = null;
      });

      break;

    default:
      break;
  }

  // Final manipulations
  // Cleanup scripts

  return { ...state };
}
